module.exports = __webpack_public_path__ + "static/media/employerImage.b008c59e.png";